import React from 'react'
import { Else, If, Then, When } from 'react-if'
import { ParagraphSM } from '@/atoms/Typography'
import { AutoFollowChatMessageContainer } from '@/molecules/AutoFollowChatMessageContainer'
import { WatchPartyChatInput } from '@/molecules/WatchPartyChatInput'
import { WatchingNowMessage } from '@/molecules/WatchingNowMessage'
import { useWatchPartyChat } from '@/services/WatchPartyChatService'
import { useTranslate } from '@/utils/translate/translate-client'

export const WatchPartyChat: React.FC = () => {
  const { t } = useTranslate('livestream')
  const { loading, timedOut, error, chatStatus, totalViewers } = useWatchPartyChat()

  return (
    <div className="relative flex h-full w-full min-w-52 flex-col justify-between overflow-hidden rounded-2xl border border-gray-700 bg-black pb-3 shadow-xl">
      <div className="flex bg-core-gray-950 p-4">
        <ParagraphSM as={(p) => <span {...p} />} className="mr-2">
          {t('chat', 'Chat')}
        </ParagraphSM>
        <ParagraphSM as={(p) => <span {...p} />} className="opacity-50" fontWeight="font-light">
          <If condition={loading}>
            <Then>{t('chatLoading', '(connecting...)')}</Then>
            <Else>
              <If condition={Boolean(timedOut || error)}>
                <Then>{t('chatError', '(error)')}</Then>
                <Else>
                  <When condition={chatStatus === 'online'}>{t('chatOnline', '(online)')}</When>
                  <When condition={chatStatus === 'offline'}>{t('chatOffline', '(offline)')}</When>
                </Else>
              </If>
            </Else>
          </If>
        </ParagraphSM>
        <If condition={totalViewers}>
          <Then>
            <div className="ml-auto w-fit rounded-lg bg-gray-900 px-3 py-1 text-xs text-gray-300">
              <WatchingNowMessage totalViewers={totalViewers} />
            </div>
          </Then>
        </If>
      </div>
      <AutoFollowChatMessageContainer>
        <WatchPartyChatInput />
      </AutoFollowChatMessageContainer>
    </div>
  )
}
